import React, { Component } from 'react'
import { withRouter } from 'react-router'
import cx from 'classnames'

import { Button } from '@/components'

@withRouter
export default class Stepper extends Component {
  state = { step: this.initialStepId, error: '' }

  get initialStepId() {
    const { step, steps } = this.props
    const { id: initialStepId } = steps[0]
    return step || initialStepId || 0
  }
  get steps() {
    const { steps } = this.props
    return steps.filter(({ isDisabled }) => !isDisabled)
  }
  get step() {
    const { step: stepProp } = this.props
    const { step: stepState } = this.state
    return stepProp || stepState
  }
  get stepIndex() {
    const { step: stepId } = this.state
    return this.getStepIndexById(stepId)
  }
  get stepProps() {
    const { steps } = this.props
    return steps.filter(
      (step, index) => step.id === this.step || index === this.step,
    )[0]
  }
  getStepIdByIndex = (index) => {
    const { steps } = this.props
    const { id } = steps[index] || {}
    return id || index
  }
  getStepIndexById = (stepId) => {
    const { steps } = this.props
    return steps.findIndex(
      (step, index) => step.id === stepId || index === stepId,
    )
  }
  setStep = (stepIndex) => {
    const { onChangeStep } = this.props
    const step = this.getStepIdByIndex(stepIndex)
    if (onChangeStep) return onChangeStep(step)
    return this.setState({ error: '', step })
  }
  scrollToTop = () => {
    return document.querySelectorAll('.AppLayout')[0].scrollTo(0, 0)
  }
  next = () => {
    const { steps } = this.props
    this.scrollToTop()
    if (this.stepIndex !== steps.length - 1) {
      this.setStep(this.stepIndex + 1)
    }
  }
  back = () => {
    if (this.stepIndex === 0) return
    this.scrollToTop()
    return this.setStep(this.stepIndex - 1)
  }
  done = () => {
    const { steps } = this.props
    if (this.stepIndex !== steps.length - 1) return
    this.scrollToTop()
    return this.setStep(0)
  }
  render() {
    const { className, error, onDone, steps } = this.props
    const {
      component: stepComponent,
      isDisabledSteps,
      isHiddenFooter,
      next,
      previous,
      validation,
    } = this.stepProps || {}
    const {
      isLoading: isLoadingNext,
      onClick: onClickNext,
      text: nextText,
    } = next || {}
    const { isHidden } = previous || {}

    return (
      <div
        className={cx(
          'Stepper',
          {
            'Stepper--is-done': this.stepIndex === steps.length - 1,
          },
          className,
        )}
      >
        <div className="Stepper__header">
          <div
            className={cx('Stepper__steps', {
              'Stepper__steps--is-disabled': isDisabledSteps || isLoadingNext,
            })}
          >
            {steps.map((step, index) => {
              const { label } = step
              return (
                <div
                  className={cx('Stepper__step', {
                    'Stepper__step--is-active':
                      this.getStepIdByIndex(index) === this.step,
                    'Stepper__step--is-done': index < this.stepIndex,
                  })}
                  key={`Stepper__step-${index}`}
                  onClick={() =>
                    !isDisabledSteps &&
                    !isLoadingNext &&
                    index < this.stepIndex &&
                    this.setStep(index)
                  }
                  style={{ width: `${100 / steps.length}%` }}
                >
                  <div className="Stepper__step-icon">
                    {index < this.stepIndex ? (
                      <i className="fa fa-check" />
                    ) : (
                      index + 1
                    )}
                  </div>
                  <div className="Stepper__step-label">{label}</div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="steps-container"></div>
        <div className="Stepper__content">
          {error && <div>{error}</div>}
          {React.cloneElement(stepComponent, {
            ...stepComponent.props,
            setStep: this.setStep,
            stepIndex: this.stepIndex,
          })}
        </div>
        <div
          className={cx('Stepper__footer', {
            'Stepper__footer--is-hidden': isHiddenFooter,
          })}
        >
          {this.stepIndex !== 0 && !isHidden && (
            <Button
              className="Stepper__back"
              disabled={isLoadingNext || this.stepIndex === 0}
              onClick={this.back}
            >
              Previous Step
            </Button>
          )}
          {this.stepIndex < steps.length - 1 && (
            <Button
              className="Stepper__next"
              disabled={isLoadingNext || (validation && !validation())}
              isLoading={isLoadingNext || false}
              onClick={
                (onClickNext && (() => onClickNext(this.next))) || this.next
              }
            >
              {nextText || 'Next Step'}
            </Button>
          )}
          {this.stepIndex === steps.length - 1 && (
            <Button
              className="Stepper__done"
              onClick={(onDone && (() => onDone(this.done))) || this.done}
            >
              Done
            </Button>
          )}
        </div>
      </div>
    )
  }
}
